<script>
	import { onMount } from 'svelte';
    // -
    import closeIcon from './svg/close.svg';
    // -
    import { lang, showingLegal } from "./store.js";
    // -
	function hideLegal(e){
		showingLegal.set(null);
	}

</script>

<template lang="pug">
	.legal( style="transform: translateY({$showingLegal ? 0 : 100}%)" )
		button.close( on:click="{hideLegal}" ) {@html closeIcon }

		.container
			.content.max-width
				+if( '$lang === "esp"' )
					h2 Aviso legal y términos de uso (Castellano)

					p En este espacio, el USUARIO, podrá encontrar toda la información relativa a los términos y condiciones legales que definen las relaciones entre los usuarios y nosotros como responsables de esta web. Como usuario, es importante que conozcas estos términos antes de continuar tu navegación. Badiu Rescue.Como responsable de esta web, asume el compromiso de procesar la información de nuestros usuarios y clientes con plenas garantías y cumplir con los requisitos nacionales y europeos que regulan la recopilación y uso de los datos personales de nuestros usuarios. Esta web, por tanto, cumple rigurosamente con el RGPD (REGLAMENTO (UE) 2016/679 de protección de datos) y la LSSI-CE la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico.

					h3 Condiciones generales de uso
					p Las presentes Condiciones Generales regulan el uso (incluyendo el mero acceso) de las páginas de la web, integrantes del sitio web de elbadiu-rescat.com incluidos los contenidos y servicios puestos a disposición en ellas. Toda persona que acceda a la web, elbadiu-rescat.com (“Usuario”) acepta someterse a las Condiciones Generales vigentes en cada momento del portal elbadiu-rescat.com.

					h3 Datos personales que recabamos y cómo lo hacemos
					p Leer Política de Privacidad

					h3 Compromisos y obligaciones de los usuarios
					p El Usuario queda informado, y acepta, que el acceso a la presente web no supone, en modo alguno, el inicio de una relación comercial con elbadiu-rescat.com. De esta forma, el usuario se compromete a utilizar el sitio Web, sus servicios y contenidos sin contravenir la legislación vigente, la buena fe y el orden público.


					+elseif( '$lang === "cat"' )
						h2 Aviso legal y términos de uso (Català)

						p En este espacio, el USUARIO, podrá encontrar toda la información relativa a los términos y condiciones legales que definen las relaciones entre los usuarios y nosotros como responsables de esta web. Como usuario, es importante que conozcas estos términos antes de continuar tu navegación. Badiu Rescue.Como responsable de esta web, asume el compromiso de procesar la información de nuestros usuarios y clientes con plenas garantías y cumplir con los requisitos nacionales y europeos que regulan la recopilación y uso de los datos personales de nuestros usuarios. Esta web, por tanto, cumple rigurosamente con el RGPD (REGLAMENTO (UE) 2016/679 de protección de datos) y la LSSI-CE la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico.

						h3 Condiciones generales de uso
						p Las presentes Condiciones Generales regulan el uso (incluyendo el mero acceso) de las páginas de la web, integrantes del sitio web de elbadiu-rescat.com incluidos los contenidos y servicios puestos a disposición en ellas. Toda persona que acceda a la web, elbadiu-rescat.com (“Usuario”) acepta someterse a las Condiciones Generales vigentes en cada momento del portal elbadiu-rescat.com.

						h3 Datos personales que recabamos y cómo lo hacemos
						p Leer Política de Privacidad

						h3 Compromisos y obligaciones de los usuarios
						p El Usuario queda informado, y acepta, que el acceso a la presente web no supone, en modo alguno, el inicio de una relación comercial con elbadiu-rescat.com. De esta forma, el usuario se compromete a utilizar el sitio Web, sus servicios y contenidos sin contravenir la legislación vigente, la buena fe y el orden público.


						+else()
							h2 Aviso legal y términos de uso (English)

							p En este espacio, el USUARIO, podrá encontrar toda la información relativa a los términos y condiciones legales que definen las relaciones entre los usuarios y nosotros como responsables de esta web. Como usuario, es importante que conozcas estos términos antes de continuar tu navegación. Badiu Rescue.Como responsable de esta web, asume el compromiso de procesar la información de nuestros usuarios y clientes con plenas garantías y cumplir con los requisitos nacionales y europeos que regulan la recopilación y uso de los datos personales de nuestros usuarios. Esta web, por tanto, cumple rigurosamente con el RGPD (REGLAMENTO (UE) 2016/679 de protección de datos) y la LSSI-CE la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico.

							h3 Condiciones generales de uso
							p Las presentes Condiciones Generales regulan el uso (incluyendo el mero acceso) de las páginas de la web, integrantes del sitio web de elbadiu-rescat.com incluidos los contenidos y servicios puestos a disposición en ellas. Toda persona que acceda a la web, elbadiu-rescat.com (“Usuario”) acepta someterse a las Condiciones Generales vigentes en cada momento del portal elbadiu-rescat.com.

							h3 Datos personales que recabamos y cómo lo hacemos
							p Leer Política de Privacidad

							h3 Compromisos y obligaciones de los usuarios
							p El Usuario queda informado, y acepta, que el acceso a la presente web no supone, en modo alguno, el inicio de una relación comercial con elbadiu-rescat.com. De esta forma, el usuario se compromete a utilizar el sitio Web, sus servicios y contenidos sin contravenir la legislación vigente, la buena fe y el orden público.
					
</template>




<style global lang="stylus">
	@require "./stylus/globals"
	// -
    .legal
        absolute100()
        position fixed
        color $orange
        background-color $n
        z-index 99
        box-shadow 0px -10px 30px rgba(0,0,0,0.3), 0px -2px 4px rgba(0,0,0,0.5)

        will-change transform
        transition transform 1s cubic-bezier(0.49, 0.13, 0.21, 0.97)

        button.close
            position fixed
            margin 0
            padding 5px 15px
            color $orange
            background transparent
            border none
            cursor pointer
            z-index 400

            top 70px
            right 20px
            width 60px
            @media $Md
                width 60px
            @media $Sm
                top 50px
                right 0px

            svg
                transform scale(0.8)
                will-change transform
                transition transform 0.18s ease-out

                line
                    stroke $orange
                    stroke-width 4
                    stroke-linecap round

                    will-change stroke
                    transition stroke 0.18s ease-out

            &:hover
                svg
                    transform scale(1)
                    line
                        stroke $b

        .container
            absolute100()
            overflow hidden
            overflow-y auto

            padding 10vh 0

            @media $Md
                padding 10vh 30px
            
            .content
                color $orange
                text-align center
                font-size 15px
                line-height 1.4em

                h2,
                h3
                    color $b
                    margin 0
                    font-weight 400
                    margin-bottom 0.8em
                    line-height 1em

                h2
                    font-size 35px

                    @media $Md
                        font-size 28px

                h3
                    text-transform uppercase
                    font-size 30px

                    @media $Md
                        font-size 24px

                p
                    margin-bottom 2.5em

</style>